<!--
 * @Author: caogt
-->
<template>
  <div class="template-container">
    <div class="main-box">
      <div class="main-content">{{ $t('fayj.text1') }}</div>
    </div>
    <div class="main-box2">
      <div class="main main-list">
        <div class="list-item" v-for="(item,index) in $t('fayj.list1')" :key=index>
          <div class="title">{{item.title}}</div>
          <div class="text" :class="index%2===1?'text2':''" v-for="(i,k) in item.info" :key=k>{{i}}</div>
        </div>
      </div>
    </div>
    <div class="main-box3">
      <div class="main">
        <div class="name">{{ $t('fayj.text2') }}</div>
        <div class="box3-fa">
          <div class="fa-item" v-for="(item,index) in $t('fayj.list2')" :key=index>
            <img class="fa-img" :src="item.url">
            <div class="fa-name">{{item.title}}</div>
            <div class="fa-grid">
              <div v-for="(i,k) in item.info" :key=k>{{ i }} </div>
            </div>
          </div>
        </div>
        <div class="name">{{ $t('fayj.text3') }}</div>
        <div class="box3-al">
          <div class="al-name">{{$t('fayj.list3')[ix].title}}</div>
          <div class="al-box">
            <img class="al-img" :src="$t('fayj.list3')[ix].url">
            {{$t('fayj.list3')[ix].info}}
          </div>
          <div class="al-page">
            <div class="page-item " v-for="(item,i) in $t('fayj.list3')" :key="i" :class="ix===i? 'item2':''" @click="ix=i">
              {{i+1}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
// import { isMobileDevice } from '@/common/scripts/isMobile.js';

export default {
  data() {
    return {

      ix:0
    };
  },
  mounted() {},
  methods: {

  },
};
</script>

<style scoped lang="stylus">
.template-container {
  width: 100%;
  .main{
    width: 1280px;
  }
  .main-box{
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-size: cover;
    background-position: top;
    background-image: url("/static/images/v2/hyfa/yj_bg1.png");
    width: 100%;
    height: 22.5vw;
    .main-content{
      font-size: 64px;
      font-weight: 800;
      color: #FFFFFF;
      width: 1280px;
    }
  }
  .main-box2{
    display: flex;
    justify-content: center;
    width: 100%;
    .main-list{
      display: grid;
      grid-template-columns: 1fr 1fr;
      column-gap: 20px;
      row-gap: 10px;
    }
    .list-item{
      margin-top: 55px;
      margin-bottom: 50px;
      .title{
        height: 80px;
        font-size: 30px;
        font-weight: 800;
        color: #111111;

      }
      .text{
        line-height: 22px;
        margin-top: 12px;
        box-sizing: border-box;
        padding: 19px;
        display: flex;
        align-items: center;
        height: 121px;
        background: #FFF7F7;
        border: 1px solid #D8D8D8;
        font-size: 16px;
        color: #111111;
        border-radius: 10px;
      }
      .text2{
        background: #F7FFFD;
        border: 1px solid #D8D8D8;
      }
    }
  }
  .main-box3{
    background: #E8E8E8;
    display: flex;
    justify-content: center;
    .name{
      margin-top: 71px;
      margin-bottom: 23px;
      text-align: center;
      color: #111111;
      font-size: 36px;
      font-weight: 600;
    }
    .box3-fa{
      padding: 40px;
      display: flex;
      background: #FFFFFF;
      border-radius: 10px;
      border: 1px solid #DCDCDC;
      .fa-item{
        flex: 1;
        margin-left: 20px;
        margin-right: 20px;
      }
      .fa-img{
        border-radius: 10px;
        height: 231px;
      }
      .fa-name{
        margin-top: 14px;
        font-size: 20px;
        font-weight: 600;
        color: #111111;
        margin-bottom: 20px;
      }
      .fa-grid{
        padding-left: 18px;
        border-left:1px solid #F6F6F6;
        color: #3D3D3D;
        font-size: 16px;
        display: grid;
        grid-template-columns: 1fr 1fr;
        column-gap: 20px;
        row-gap: 12px;
      }
    }
    .box3-al{
      margin-bottom: 75px;
      background: #FFFFFF;
      border-radius: 10px;
      border: 1px solid #DCDCDC;
      padding: 28px;
      .al-name{
        margin-top: 40px;
        margin-bottom: 20px;
        font-size: 32px;
        font-weight: 600;
        color: #1F65FE;
      }
      .al-box{
        border-bottom: 1px solid  #D8D8D8;
        padding-bottom: 40px;
        padding-right: 20px;
        font-size: 14px;
        font-weight: normal;
        line-height: 22px;
        color: #383838;
        display: flex;
        .al-img{
          margin-right: 50px;
          width: 580px;
          height: 400px;
        }
      }
      .al-page{
        display: flex;
        .page-item{
          cursor: pointer;
          margin-bottom: -10px;
          text-align: center;
          margin-top: 23px;
          margin-right: 5px;
          width: 48px;
          height: 48px;
          border-radius: 6px;
          font-size: 16px;
          font-weight: 600;
          line-height: 46px;
          border: 1px solid #111111;
        }
        .item2{
          border: 1px solid #1F65FE;
          color: #1F65FE;
        }
      }
    }
  }
}

@media all and (max-width: 768px) {
  .template-container {
    width: 100%;
    .main{
      width: 100%;
    }
    .main-box{
      display: flex;
      flex-direction: column;
      justify-content: center;
      background-size: cover;
      background-position: top;
      background-image: url("/static/images/v2/hyfa/yj_bg1.png");
      width: 100%;
      height: 58.3vw;
      .main-content{
        margin-left: 10px;
        font-size: 50px;
        font-weight: 800;
        color: #FFFFFF;
        width: 100%;
      }
    }
    .main-box2{
      display: flex;
      justify-content: center;
      width: 100%;
      .main-list{
        padding: 0 20px;
        display: grid;
        grid-template-columns: 1fr;
        column-gap: 20px;
        row-gap: 10px;
      }
      .list-item{
        margin-top: 55px;
        margin-bottom: 50px;
        .title{
          font-size: 30px;
          font-weight: 800;
          color: #111111;

        }
        .text{
          line-height: 22px;
          margin-top: 12px;
          box-sizing: border-box;
          padding: 19px;
          display: flex;
          align-items: center;
          height: 121px;
          background: #FFF7F7;
          border: 1px solid #D8D8D8;
          font-size: 16px;
          color: #111111;
          border-radius: 10px;
        }
        .text2{
          background: #F7FFFD;
          border: 1px solid #D8D8D8;
        }
      }
    }
    .main-box3{
      background: #E8E8E8;
      display: flex;
      justify-content: center;
      .name{
        margin-top: 71px;
        margin-bottom: 23px;
        text-align: center;
        color: #111111;
        font-size: 36px;
        font-weight: 600;
      }
      .box3-fa{
        padding: 5px;
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #FFFFFF;
        border-radius: 10px;
        border: 1px solid #DCDCDC;
        .fa-item{
          flex: 1;
          margin-left: 1px;
          margin-right: 1px;
        }
        .fa-img{
          margin-top: 20px;
          border-radius: 10px;
          height: auto;
        }
        .fa-name{
          margin-top: 14px;
          font-size: 20px;
          font-weight: 600;
          color: #111111;
          margin-bottom: 20px;
        }
        .fa-grid{
          margin-bottom: 20px;
          padding-left: 18px;
          border-left:1px solid #F6F6F6;
          color: #3D3D3D;
          font-size: 16px;
          display: grid;
          grid-template-columns: 1fr 1fr;
          column-gap: 20px;
          row-gap: 12px;
        }
      }
      .box3-al{
        margin-bottom: 75px;
        background: #FFFFFF;
        border-radius: 10px;
        border: 1px solid #DCDCDC;
        padding: 28px;
        .al-name{
          margin-top: 40px;
          margin-bottom: 20px;
          font-size: 32px;
          font-weight: 600;
          color: #1F65FE;
        }
        .al-box{
          border-bottom: 1px solid  #D8D8D8;
          padding-bottom: 40px;
          padding-right: 20px;
          font-size: 14px;
          font-weight: normal;
          line-height: 22px;
          color: #383838;
          display: flex;
          flex-direction: column;
          .al-img{
            width: 100%;
            height: auto;
            margin-bottom: 20px;
          }
        }
        .al-page{
          display: flex;
          .page-item{
            cursor: pointer;
            margin-bottom: -10px;
            text-align: center;
            margin-top: 23px;
            margin-right: 5px;
            width: 48px;
            height: 48px;
            border-radius: 6px;
            font-size: 16px;
            font-weight: 600;
            line-height: 46px;
            border: 1px solid #111111;
          }
          .item2{
            border: 1px solid #1F65FE;
            color: #1F65FE;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/industry/hyfa/fayj.vue